module.exports = __webpack_public_path__ + "img/github.91103ec8.svg";